import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
} from '@angular/core';
import { translate } from '../utils/translate.function';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({
  selector: '[localizer]',
  standalone: true,
})
export class LocalizerDirective implements OnChanges {
  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly r2: Renderer2
  ) {}

  @Input() set localizer(key: string) {
    if (!key) return;

    this.r2.setProperty(this.el.nativeElement, 'textContent', translate(key));
  }

  ngOnChanges(): void {
    this.localizer = this.el.nativeElement.textContent;
  }
}
